import React, { PureComponent } from 'react';
import cn from 'classnames';
import Select from 'react-select';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { FormGroup, Label } from 'reactstrap';
import { array, number, func, bool, node } from 'prop-types';

class FlowTDS extends PureComponent {
  static propTypes = {
    tdsId: number.isRequired,
    tdsStreams: array.isRequired,
    onTDSChange: func.isRequired,
    error: node,
    intl: intlShape.isRequired,
    disabled: bool.isRequired,
  };

  static defaultProps = {
    tdsStreams: [],
    onTDSChange() {},
    error: '',
  };

  renderSelectNoResultsText = () => {
    const { intl } = this.props;
    return intl.formatMessage({
      id: 'flow.form.tds.no-results-text',
      defaultMessage: 'TDS not found',
    });
  };

  render() {
    const { className, tdsId, tdsStreams, onTDSChange, error, disabled, theme } = this.props;

    return (
      <FormGroup className={cn(className, { 'has-error': error })}>
        <Label for="tdsStreams">
          <FormattedMessage id="flow.form.tds" defaultMessage="TDS stream" />
        </Label>
        <Select
          id="tdsStreams"
          name="tdsId"
          clearable={false}
          value={tdsId}
          placeholder={<FormattedMessage id="main.select" defaultMessage="Select..." />}
          onChange={onTDSChange}
          options={tdsStreams.map(({ title: label, id: value }) => ({
            value,
            label,
          }))}
          disabled={disabled}
          noResultsText={this.renderSelectNoResultsText()}
        />
        {error && <small className="form-text">{error}</small>}
      </FormGroup>
    );
  }
}

export default injectIntl(FlowTDS);
